import APPCONFIG from '../constants/Config';
import {
    AUTHENTICATE_USER, SET_USER_ROLE, SET_USER_DETAILS
} from '../constants/ActionTypes';

import LocalStorageService from '../services/LocalStorageService'; var ls = LocalStorageService;

const initialSettings = APPCONFIG.settings;


const auth = (state = { auth: false, role: '', user: {} }, action) => {
    // console.log(action)
    switch (action.type) {
        case AUTHENTICATE_USER:
            {
                action.auth ? null : ls.logout()
                return {
                    ...state,
                    auth: action.auth
                };
            }
        case SET_USER_ROLE:
            {
                return {
                    ...state,
                    role: action.role
                };
            }
        case SET_USER_DETAILS:
            {
                return {
                    ...state,
                    user: action.user
                };
            }
        default:
            return state;
    }
};

module.exports = auth;


// WEBPACK FOOTER //
// ./reducers/auth.js